import {
  collection,
  deleteDoc,
  doc,
  getDocs,
  runTransaction,
} from "firebase/firestore";
import { db } from "../config/firebase";

const deletedEventsCollection = collection(db, "deleted_events");

const deletedEventService = {
  getAll: async () => {
    try {
      const deletedEventsSnapshot = await getDocs(deletedEventsCollection);
      const deletedEventsList = deletedEventsSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      return deletedEventsList;
    } catch (error) {
      console.error("Error fetching deleted events:", error);
      throw error;
    }
  },

  restore: async (deletedEventId) => {
    try {
      const deletedEventRef = doc(db, "deleted_events", deletedEventId);
      const restoredRef = doc(db, "events", deletedEventId);

      await runTransaction(db, async (transaction) => {
        const [deletedEventSnap, existingEventSnap] = await Promise.all([
          transaction.get(deletedEventRef),
          transaction.get(restoredRef),
        ]);

        if (!deletedEventSnap.exists()) {
          throw new Error("Deleted event not found");
        }
        if (existingEventSnap.exists()) {
          throw new Error(
            `Cannot restore: another event already uses ID ${deletedEventId}`
          );
        }

        transaction.set(restoredRef, {
          ...deletedEventSnap.data(),
          original_id: deletedEventId,
        });
        transaction.delete(deletedEventRef);
      });

      return restoredRef.id;
    } catch (error) {
      console.error("Error restoring event:", error);
      throw error;
    }
  },

  delete: async (deletedEventId) => {
    try {
      const deletedEventRef = doc(db, "deleted_events", deletedEventId);
      await deleteDoc(deletedEventRef);
      return true;
    } catch (error) {
      console.error("Error permanently deleting event:", error);
      throw error;
    }
  },
};

export default deletedEventService;
